import FormComponents from "components/forms/FormComponents";
import { Icon, Modal } from "enums";
import manager from "managers/app";
import ModalContent from "modals/content/ModalContent";
import { VariantsModalProps } from "modals/content/variants/types";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./VariantsModal.css";

const mapStateToProps = (state:AppState):VariantsModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		variants: state.modal[Modal.VARIANT],
	};
};

class VariantsModal extends Component<VariantsModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.VARIANT} className="modal-wrapper">
				<ModalHeader text="Variant & Criteon Dungeons" icon={Icon.DUTY} />
				<ModalContent>
					<div className="variant-wrapper">
						{this.props.variants.map((variant) => {
							return <div key={variant} className="variant-card">
								<h3 className="variant-name">{t.t(variant)}</h3>
							</div>;
						})}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}
}
export default connect(mapStateToProps)(VariantsModal);
